// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tag[data-v-144fa35d] {\n  margin-right: 10px;\n}\n[data-v-144fa35d] .bj-page .el-form-item__label {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
